<template>
    <NuxtLayout>
        <NuxtPage :key="previewTimestamp" />
    </NuxtLayout>
</template>

<script setup>
    const { previewTimestamp } = usePreview()

</script>